import React from 'react';
import "./ui.css";
import { Btn } from '../../utils/utils';
import feature from "../../assets/feature.png";

const HouseCard = ({img, tag, title, add, area, bed, bath, price, houseStyle, noOfUnits, propType, ...rest}) => {
  return (
    <div className='house-card' style={houseStyle}>
        <div className="house-card_top">
            <img src={img || feature} alt="house" />
            <h6 style={{background: tag === "Rent" ? "white" : tag === "Sell" || tag === false ? "#F08228" : "#60DB41", color: tag === "Rent" ? "#000" : "white" }}>{tag === false ? "Not Verified" : tag === true ? "Verified" : tag}</h6>
        </div>
        <div className="house-card_btm">
            <h3 className='truncate'>{title}</h3>
            <h4 className='truncate'>{add}</h4>
            <div className="house-dim">
                {area && <p>{area}sqft</p>}
                {propType && <p>{propType}</p>}
                {noOfUnits && <p>Num of Units: {noOfUnits}</p>}
                {bed && <p>{bed} bed</p>}
                {bath && <p>{bath} bath</p>}
            </div>
            {tag === "Rent" && <h5>{price}/annum</h5>}
            {tag === "Sell" && <h5>{price}</h5>}
            {tag === "Rented" && <h5>{price}</h5>}
            {price && propType !== "Land" && <h5>{price}</h5>}
            <div className="house-btn">
                <Btn btnText={"View Details"} btnClass={"home-btn"} btnWidth={"100%"} {...rest} />
            </div>
        </div>
    </div>
  )
}

export default HouseCard